/**
 * Calculate difference between two times at format hht mmm
 * @param {Timesheet} timesheet
 * @returns {String} hh(t) mm(m)
 */
window.calcTimeDifference = (timesheet) => {
    if (timesheet.out_time == null) return "0t 0m";

    const inTime = new Date(timesheet.in_time);
    const outTime = new Date(timesheet.out_time);

    const breakInMillis = getBreakInMillis(timesheet.break);

    const diff = calcDiff(inTime, outTime, breakInMillis);

    return `${diff.hours}t ${diff.min}m`;
};

/**
 * Set the timediff in js
 * @param {string} in_time
 * @param {string} out_time
 * @param {Number} break
 * @param {string} id
 */
window.calcTime = (inTimeVal, outTimeVal, pause, sum) => {
    if (!sum) return;
    if (outTimeVal == null) return (sum.innerText = "0t 0m");

    const inTime = splitTime(inTimeVal);
    let outTime = splitTime(outTimeVal);

    if (outTimeVal === "" || inTimeVal === "") return (sum.innerText = "0t 0m");

    // Handle out_time past midnights
    if (
        outTime.hours < inTime.hours ||
        (outTime.hours === inTime.hours && outTime.minutes < inTime.minutes)
    )
        outTime.hours += 24;
    const diffHours = outTime.hours - inTime.hours;
    const totalMinutes =
        diffHours * 60 + outTime.minutes - inTime.minutes - pause;

    if (totalMinutes <= 0) return (sum.innerText = "0t 0m"); // Occur if pause is more than in-out diff

    const displayHours = Math.floor(totalMinutes / 60);
    const displayMinutes = Math.floor(totalMinutes % 60);

    sum.innerText = `${displayHours}t ${displayMinutes}m`;
};

window.splitTime = (time) => {
    const arr = time.split(":");
    return { hours: parseInt(arr[0]), minutes: parseInt(arr[1]) };
};

/**
 * Handle firefox time input bug and returns hour and minutes
 * @param {string} time
 * @returns {Object} {hours: Number, minutes: Number}
 */
window.splitTimeString = (time) => {
    const formatedTime = time.replaceAll("-", "/") + " UTC";
    const date = `${new Date(formatedTime).getHours()}:${new Date(
        formatedTime
    ).getMinutes()}`;
    const arr =
        date.split(":")[0] == "NaN" ? formatedTime.split(":") : date.split(":");
    return { hours: parseInt(arr[0]), minutes: parseInt(arr[1]) };
};

// GetLocalDateTime

// CalcTotalTime

// GetLocalTime

window.getLocalDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
};

window.calcTotalTime = (timesheets) => {
    let hours = 0;
    let minutes = 0;
    timesheets.forEach((timesheet) => {
        if (timesheet.out_time === null) return;
        const breakInMillis = getBreakInMillis(timesheet.break);
        const diff = calcDiff(
            timesheet.in_time,
            timesheet.out_time,
            breakInMillis
        );
        hours += diff.hours;
        minutes += diff.min;
    });
    hours += Math.floor(minutes / 60);
    return `${hours}t ${minutes % 60}m`;
};

window.getLocalTime = (time) => {
    if (!time) {
        return "";
    }
    return new Date(time).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });
};

window.getLocalDate = (date) => {
    date = new Date(date);
    let dateNum = date.getDate().toString();
    let monthNum = (date.getMonth() + 1).toString();
    const day = getDayString(date.getDay());
    if (dateNum.length === 1) dateNum = "0" + dateNum;
    if (monthNum.length === 1) monthNum = "0" + monthNum;
    return `${day} ${dateNum}.${monthNum}`;
};

var getDayString = (dayOfWeek) => {
    switch (dayOfWeek) {
        case 0:
            return "Søn";
        case 1:
            return "Man";
        case 2:
            return "Tirs";
        case 3:
            return "Ons";
        case 4:
            return "Tors";
        case 5:
            return "Fre";
        case 6:
            return "Lør";
    }
};

var calcDiff = (inTime, outTime, breakInMillis) => {
    let diffInTime = new Date(outTime).getTime() - new Date(inTime).getTime();

    diffInTime -= breakInMillis;

    const hours = Math.floor(diffInTime / (60 * 60 * 1000));
    const min = Math.floor((diffInTime % (60 * 60 * 1000)) / (60 * 1000));

    return { hours: hours, min: min };
};

var getBreakInMillis = (pause) => {
    const breaks = pause.split(":");
    const breakHours = parseInt(breaks[0]);
    const breakMinutes = parseInt(breaks[1]);
    return breakHours * 60 * 60 * 1000 + breakMinutes * 60 * 1000;
};
